import React, { forwardRef } from "react";
import { Slide } from "@mui/material";

export const ORANGE = "#FF9015";
export const TRANSITION = "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)";

export const INPUT_SX = {
  "& input": { fontSize: "16px" },
  "& textarea": { fontSize: "16px" },
  "& .MuiOutlinedInput-root": {
    // size="small" renders a 40px control; a form field is a tap target too.
    minHeight: 44,
    borderRadius: "12px",
    transition: TRANSITION,
    "& fieldset": { borderColor: "rgba(0,0,0,0.12)" },
    "&:hover fieldset": { borderColor: "rgba(0,0,0,0.25)" },
    "&.Mui-focused fieldset": {
      borderColor: ORANGE,
      boxShadow: `0 0 0 3px rgba(255,144,21,0.15)`,
    },
  },
};

export const SELECT_SX = {
  "& .MuiOutlinedInput-root": {
    minHeight: 44,
    borderRadius: "12px",
    fontSize: "16px",
    transition: TRANSITION,
    "& fieldset": { borderColor: "rgba(0,0,0,0.12)" },
    "&:hover fieldset": { borderColor: "rgba(0,0,0,0.25)" },
    "&.Mui-focused fieldset": {
      borderColor: ORANGE,
      boxShadow: `0 0 0 3px rgba(255,144,21,0.15)`,
    },
  },
};

export const severityToColor = {
  success: "success",
  info: "info",
  warning: "warning",
  danger: "error",
  null: "default",
  undefined: "default",
};

export const SlideUp = forwardRef(function SlideUp(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
